import { keepPreviousData } from '@tanstack/react-query';

import { InventoryPolicy } from '@playq/octopus2-economy';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const policyInventoryQueryKeys: unknown[] = ['corp', 'policies', 'inventory', 'query'];

export const usePolicyInventoryQuery = (
  options?: IUseQueryOptionsExtended<InventoryPolicy | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(policyInventoryQueryKeys, () => services2.inventoryAdminService.retrievePolicy(), {
    placeholderData: keepPreviousData,
    ...options,
  });
};
